module.exports = __webpack_public_path__ + "media/assets/images/blog/agile-introduction-81ffede4fe0d8c126e8b777011dc0b41.png";